/**
 * job_board — casing. The next six open jobs by scheduled day, as a strip of
 * cards that scrolls sideways.
 */
import JobStatusBoard from '../../dashboard/JobStatusBoard';
import { queryLoadFailure } from '../../../lib/load-failure';
import { WidgetPanel, WidgetPending } from '../WidgetPanel';
import { useOverviewJobs } from '../overviewQueries';

export default function JobBoardWidget() {
  const q = useOverviewJobs();
  const failure = q.data === undefined ? queryLoadFailure(q) : null;
  const jobs = (q.data ?? [])
    .filter((j: any) => j.status !== 'completed' && j.status !== 'cancelled')
    .sort((a: any, b: any) => String(a.scheduled_date || a.scheduledDate || '').localeCompare(String(b.scheduled_date || b.scheduledDate || '')))
    .slice(0, 6);

  return (
    <WidgetPanel widgetKey="job_board" eyebrow="Open jobs, soonest first" title="Job Board" link={{ label: 'Jobs', to: '/jobs' }}>
      <div className="p-4">
        {!failure && q.data === undefined ? <WidgetPending rows={2} /> : <JobStatusBoard jobs={jobs} failure={failure} />}
      </div>
    </WidgetPanel>
  );
}
